import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { saveCustomerLogo } from "@midland-industries/Services/CustomerLogosService";
import { xcentiumCustomerLogosActions } from "@midland-industries/Store/Data/CustomerLogos/CustomerLogosReducer";
import {
    SaveCustomerLogoApiResponseModel,
    SaveCustomerLogoParameter,
} from "@midland-industries/Types/CustomerLogosModels";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<xcentiumCustomerLogosActions>;

type SaveCustomerLogoApiParameter = {
    formData: FormData;
} & HasOnSuccess<SaveCustomerLogoApiResponseModel> &
    HasOnError<string>;

type HandlerType = ApiHandler<SaveCustomerLogoApiParameter, ServiceResult<SaveCustomerLogoApiResponseModel>, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const apiResult = await saveCustomerLogo(props.apiParameter.formData);
    props.apiResult = apiResult;
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const DispatchCompleteLoad: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "Custom/CustomerLogos/CompleteSave",
            params: props.apiParameter,
            result: props.apiResult.result,
        });
    }
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "Custom/CustomerLogos/CompleteSave",
            params: props.apiParameter,
            result: {} as SaveCustomerLogoApiResponseModel,
        });
    }
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    DispatchCompleteLoad,
];

const saveCurrentCustomerLogo = createHandlerChainRunner(chain, "SaveCurrentCustomerLogo");
export default saveCurrentCustomerLogo;
